import { ResponseError } from '@backstage/errors';
import { makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import { WarningPanel } from '@backstage/core-components';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class AwsApiClient {
  constructor(options) {
    __publicField(this, "backendName");
    __publicField(this, "discoveryApi");
    __publicField(this, "fetchApi");
    this.backendName = options.backendName;
    this.fetchApi = options.fetchApi;
    this.discoveryApi = options.discoveryApi;
  }
  async getBaseUrl() {
    return this.discoveryApi.getBaseUrl(this.backendName);
  }
  async get(path) {
    const baseUrl = await this.getBaseUrl();
    const url = `${baseUrl}/${path}`;
    const response = await this.fetchApi.fetch(url);
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return response.json();
  }
}

const useTabsStyles = makeStyles(
  (theme) => ({
    root: {
      padding: theme.spacing(1, 2, 0, 2.5),
      minHeight: theme.spacing(3)
    },
    indicator: {
      backgroundColor: theme.palette.info.main,
      height: theme.spacing(0.3)
    }
  }),
  { name: "TabbedContent" }
);
function TabbedContent(props) {
  const { children } = props;
  const tabsClasses = useTabsStyles();
  const [selectedIndex, selectIndex] = useState(0);
  const handleChange = (_ev, newSelectedIndex) => selectIndex(newSelectedIndex);
  let selectedTabContent;
  React.Children.map(children, (child, index) => {
    if (React.isValidElement(child) && index === selectedIndex) {
      selectedTabContent = child == null ? void 0 : child.props.children;
    }
  });
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Tabs, { classes: tabsClasses, value: selectedIndex, onChange: handleChange }, children), /* @__PURE__ */ React.createElement("div", null, selectedTabContent));
}

function MissingResources() {
  return /* @__PURE__ */ React.createElement(
    WarningPanel,
    {
      title: "No matching resources found.",
      message: /* @__PURE__ */ React.createElement(React.Fragment, null, "No AWS resources could be found that match the annotations provided.")
    }
  );
}

export { AwsApiClient, MissingResources, TabbedContent };
//# sourceMappingURL=index.esm.js.map
